import ApplicationController from "./application_controller"

// Add-to-cart wiring for the flat item-view stepper+button UI (no pre-cart/in-cart
// toggle states like opportunity_cart_controller.js - just reads the input on submit).
export default class extends ApplicationController {
  static targets = ["quantityInput", "addButton"]

  static values = {
    itemType: String,
    itemId: String,
    opportunityId: String,
    cartItemId: String,
    setQuantityUrl: String
  }

  addToCart(event) {
    event.preventDefault()
    const quantity = parseInt(this.quantityInputTarget.value, 10) || 1

    this.setLoading(true)

    fetch(this.setQuantityUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify({
        opportunity_id: this.opportunityIdValue,
        item_type: this.itemTypeValue,
        item_id: this.itemIdValue,
        quantity: quantity
      })
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          // Reload so every cart-count display on the page (header badge, MY CART) reflects the new total
          window.location.reload()
        } else {
          console.error("Add to cart error:", data.error)
          this.setLoading(false)
        }
      })
      .catch(error => {
        console.error("Error adding to cart:", error)
        this.setLoading(false)
      })
  }

  setLoading(loading) {
    // Two addButton targets exist (desktop text button + mobile square icon button,
    // toggled via CSS breakpoints) - keep both in sync regardless of which is visible.
    this.addButtonTargets.forEach(button => { button.disabled = loading })
  }

  get csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.content : ""
  }
}
